import { z } from "zod";

export enum ApiErrorCategory {
  CLIENT_ERROR = "CLIENT_ERROR",
  SERVER_ERROR = "SERVER_ERROR",
}

export enum ApiErrorType {
  AUTH_INVALID_CREDENTIALS = "AUTH_INVALID_CREDENTIALS",
  AUTH_USER_NOT_CONFIRMED = "AUTH_USER_NOT_CONFIRMED",
  AUTH_USERNAME_EXISTS = "AUTH_USERNAME_EXISTS",
  AUTH_USERNAME_DOES_NOT_EXIST = "AUTH_USERNAME_DOES_NOT_EXIST",
  AUTH_RATE_LIMIT_EXCEEDED = "AUTH_RATE_LIMIT_EXCEEDED",
  AUTH_CODE_MISMATCH = "AUTH_CODE_MISMATCH",
  AUTH_CODE_EXPIRED = "AUTH_CODE_EXPIRED",
  AUTH_USER_ALREADY_VERIFIED = "AUTH_USER_ALREADY_VERIFIED",
}

export class ApiError extends Error {
  public category: ApiErrorCategory;
  public type: ApiErrorType;

  public constructor(
    category: ApiErrorCategory,
    type: ApiErrorType,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
    this.category = category;
    this.type = type;
  }
}

export type ApiResponseWithError = {
  data: null;
  error: ApiError;
};

export const ApiErrorSchema = z.object({
  category: z.nativeEnum(ApiErrorCategory),
  type: z.nativeEnum(ApiErrorType),
  message: z.string(),
});

export const ApiErrorResponseSchema = z.object({
  error: ApiErrorSchema,
});

export class NetworkError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "NetworkError";
  }
}
